import TooltipRC from 'rc-tooltip';
import styled, { css } from 'styled-components';

type TooltipProps = {
  prefixCls: string;
};

const Tooltip = styled(TooltipRC)<TooltipProps>(
  ({ theme, prefixCls }) => css`
    position: absolute;
    z-index: 1070;

    .${prefixCls} {
      &-inner {
        background: ${theme.background.raised};
        box-shadow: ${theme.elevation.level0};
        border-radius: 4px;
      }

      &-arrow {
        position: relative;
        z-index: 1;
        overflow: hidden;

        &::before {
          position: absolute;
          content: '';
          display: block;
          width: 12px;
          height: 12px;
          background: ${theme.background.raised};
          box-shadow: rgb(0 0 0 / 2%) 0 0 4px 0, rgb(0 0 0 / 4%) 0 0 0 1px;
        }
      }
    }

    &.${prefixCls} {
      &-hidden {
        display: none;
      }

      /* Placement top or bottom */
      &-placement-bottomLeft,
      &-placement-bottomRight,
      &-placement-bottom,
      &-placement-topLeft,
      &-placement-topRight,
      &-placement-top {
        .${prefixCls}-arrow {
          width: 24px;
          height: 10px;

          ::before {
            left: 50%;
            transform: translateX(-50%) rotate(45deg);
          }
        }

        > div {
          display: flex;
        }
      }

      /* Placement left or right */
      &-placement-leftTop,
      &-placement-leftBottom,
      &-placement-left,
      &-placement-rightTop,
      &-placement-rightBottom,
      &-placement-right {
        .${prefixCls}-arrow {
          width: 10px;
          height: 24px;

          ::before {
            top: 50%;
            transform: translateY(-50%) rotate(45deg);
          }
        }

        > div {
          display: flex;
        }
      }

      /* Placement bottom */
      &-placement-bottomLeft,
      &-placement-bottomRight,
      &-placement-bottom {
        .${prefixCls}-arrow::before {
          top: 4px;
        }

        > div {
          flex-direction: column;
        }
      }

      /* Placement top */
      &-placement-topLeft,
      &-placement-topRight,
      &-placement-top {
        .${prefixCls}-arrow::before {
          bottom: 4px;
        }

        > div {
          flex-direction: column-reverse;
        }
      }

      /* Placement left */
      &-placement-leftTop,
      &-placement-left,
      &-placement-leftBottom {
        .${prefixCls}-arrow::before {
          right: 4px;
        }

        > div {
          flex-direction: row-reverse;
        }
      }

      /* Placement right */
      &-placement-rightTop,
      &-placement-right,
      &-placement-rightBottom {
        .${prefixCls}-arrow::before {
          left: 4px;
        }

        > div {
          flex-direction: row;
        }
      }

      /* Alignment vertical bottom */
      &-placement-rightBottom,
      &-placement-leftBottom {
        > div {
          align-items: end;
        }
      }

      /* Alignment center */
      &-placement-bottom,
      &-placement-top,
      &-placement-left,
      &-placement-right {
        > div {
          align-items: center;
        }
      }

      /* Alignment right */
      &-placement-bottomRight,
      &-placement-topRight {
        > div {
          align-items: end;
        }
      }
    }
  `,
);

export { Tooltip };
